const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  RESET_PASSWORD: 'user/RESET_PASSWORD',
  DELETE_TOKEN_RESET: 'user/DELETE_TOKEN_RESET',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
}

export default actions
